export const LinkRenderer = (col) => (rowData) => {
    const url = rowData?.[col.field];
    if (!url) return "-";

    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;

    return (
        <a href={href} target="_blank"
            rel="noopener noreferrer" className="grid-link"
            onClick={(e) => e.stopPropagation()}
            title={url}>
            {col.linkText ? typeof col.linkText === "function"
                ? col.linkText(rowData) : col.linkText : url}
        </a>
    );
};
